import { Button, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import useAuth from "../../../../../../../context/auth"

interface Props {
    open: boolean,
    onClose: () => void
}

export const PayDailys = ({
    onClose,
    open
}: Props) => {
    const { setTab } = useAuth()
    return (
        <ModalComponent
            open={open}
            title="Atenção"
            titleProps={{
                color: "rgba(218, 23, 23, 0.9)",
                fontWeight: 700,
                fontSize: "2rem"
            }}
            showButtonClose={false}
            onClose={onClose}
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.5em"}
                alignItems={"center"}
            >


                <Typography fontSize={"1.5rem"} lineHeight={"1.8rem"}>
                    Antes de sacar o saldo disponível é necessário que você <strong>pague as suas diárias pendentes.</strong>
                </Typography>

                <Button
                    variant="contained"
                    sx={{
                        width: "100%",
                        maxWidth: "22.3rem",
                        height: "4rem",
                        mb: "-1.5rem"
                    }}
                    onClick={() => {
                        onClose()
                        setTab(0)
                    }}
                >Ir para Diárias Pendentes</Button>
            </Grid>
        </ModalComponent>
    )
}